<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <el-row>
            <el-col :span="2" style="height:1px;"></el-col>
            <el-col :span="20" :class="$style.wrapper" class="subjectList">
                <div :class="$style.top">
                    <el-form ref="form" :model="form" label-width="80px">
                        <div :class="$style.wrap">
                            <el-form-item label="所属区域" prop="area">
                                <el-select v-model="region" v-on:change="handleBranchsClick" clearable
                                           placeholder="选择区域" size="small" style="width: 230px;">
                                    <el-option v-for="item in regionArray" :key="item.region_id"
                                               :label="item.region_name"
                                               :value="item.region_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="省份" prop="provinces">
                                <el-select v-model="provinces" v-on:change="handleProvincesClick" clearable
                                           placeholder="选择省份" size="small" style="width: 230px;">
                                    <el-option v-for="item in provinceArray" :key="item.province_id"
                                               :label="item.province_name"
                                               :value="item.province_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="城市" prop="city">
                                <el-select v-model="city" clearable placeholder="选择城市" :disabled="isShowCity"
                                           size="small"
                                           style="width: 230px;">
                                    <el-option v-for="item in selectCityArray" :key="item.city_id"
                                               :label="item.city_name"
                                               :value="item.city_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="巡查门店">
                            <el-input v-model="name" placeholder="请输入门店名称或地址"></el-input>
                        </el-form-item>
                        <el-form-item label="巡店模板" prop="templates" class="a_modal">
                            <el-select v-model="templates" clearable
                                       placeholder="选择模板" size="small">
                                <el-option v-for="item in templateArray" :key="item.template_id"
                                           :label="item.template_name"
                                           :value="item.template_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="巡店日期">
                            <el-date-picker
                                    v-model="startDate"
                                    type="date"
                                    :picker-options="beforPickerOptions"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span :class="$style.font">至</span>
                            <el-date-picker
                                    v-model="endDate"
                                    type="date"
                                    :picker-options="afterPickerOptions"
                                    placeholder="选择日期"
                                    >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态">
                            <template>
                                <el-checkbox-group v-model="status">
                                    <el-checkbox label="未完成"></el-checkbox>
                                    <el-checkbox label="已完成"></el-checkbox>
                                </el-checkbox-group>
                            </template>
                        </el-form-item>
                    </el-form>
                    <el-row>
                        <el-button type="primary" @click.stop="handleQueryClick">查询</el-button>
                        <el-button type="danger" @click.stop="handleResetClick">重置</el-button>
                    </el-row>
                </div>
                <div :class="$style.border"></div>
                <div :class="$style.bottom">
                    <el-table
                            :data="tableData"
                            border
                            style="width: 100%" :class="$style.table"
                            :default-sort="{prop: 'startTime', order: 'descending'}"
                    >
                        <el-table-column
                                type="index"
                                label="序号"
                                width="60px"
                        >
                        </el-table-column>
                        <el-table-column
                                property="name"
                                label="门店名称"
                                sortable
                                min-width="150"
                        >
                        </el-table-column>

                        <el-table-column
                                property="province"
                                label="省份"
                                sortable
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                property="city"
                                label="城市"
                                sortable
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                property="templatename"
                                label="巡店模板"
                                sortable
                                width="150"
                        >
                        </el-table-column>
                        <el-table-column
                                property="last_name"
                                label="巡店人员 "
                                sortable
                                width="110"
                        >
                        </el-table-column>
                        <el-table-column
                                property="time"
                                label="巡店日期"
                                sortable
                                width="110"
                        >
                        </el-table-column>
                        <el-table-column
                                property="completed"
                                label="状态"
                                sortable
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                property="score"
                                label="检查事项总分"
                                sortable
                                width="130"
                        >
                        </el-table-column>
                        <el-table-column
                                property="average"
                                label="店员评估平均分"
                                sortable
                                width="150"
                        >
                        </el-table-column>


                        <el-table-column
                                fixed="right" label="操作"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <el-button
                                        type="warning" size="small"
                                        @click="handleDetail(scope.$index, scope.row)">详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :page="page" @changePage="changePageClick"></pagination>
                </div>
            </el-col>
            <el-col :span="2"></el-col>
        </el-row>
        <!--<Modal :showModal="showModal" :template="courseTemplate" :lists="lists"-->
        <!--:title="title" :subTitle="subTitle" @closeModal="closeModal"-->
        <!--/>-->
    </div>
</template>

<script>
    import http from '../../APIService/http'
    import pagination from '../../components/pagination'

    export default {
        data() {
            return {
                loading: false,

                regionArray: [],
                provinceArray: [],
                cityArray: [],
                selectCityArray: [],
                templateArray: [],

                region: '',
                provinces: '',
                city: '',
                templates: '',
                name: '',
                startDate: '',
                endDate: '',
                status: [],
                beforPickerOptions: {

                    disabledDate: (time) => {
                        let endDate = new Date(this.endDate)
                        endDate.setHours(0)
                        endDate.setMinutes(0)
                        endDate.setSeconds(0)

                        if (endDate) {
                            return time.getTime() > endDate
                        }
                    }
                },
                afterPickerOptions: {

                    disabledDate: (time) => {
                        let startDate = new Date(this.startDate)
                        startDate.setHours(0)
                        startDate.setMinutes(0)
                        startDate.setSeconds(0)

                        if (startDate) {
                            return time.getTime() < startDate
                        }
                    }
                },

                tableData: [],
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                user: {}
            }
        },
        components: {
            pagination
        },
        computed: {
            isShowCity() {
                if (this.provinces.length > 0) {
                    return false
                }
                return true
            },
        },
        created() {
            this.getAreaTemplateCity()
            this.init()
        },
        methods: {
            async init() {


                this.loading = true

                try {
                    var s = ''
                    if (this.status.length > 0) {

                        for (var i = 0; i < this.status.length; i++) {
                            var str = this.status[i]
                            if (str === "已完成") {
                                str = "T"
                            }
                            else if (str === "未完成") {
                                str = ""
                            }

                            if (i === this.status.length - 1) {
                                s = s + '\'' + str + '\''
                            } else {
                                s = '\'' + str + '\'' + ','
                            }
                        }
                    }

                    let data = {
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        region: this.region,
                        provinces: this.provinces,
                        city: this.city,
                        name: this.name,
                        templates: this.templates,
                        startDate: this.startDate ? new Date(this.startDate).Format('yyyy-MM-dd') : '',
                        endDate: this.endDate ? new Date(this.endDate).Format('yyyy-MM-dd') : '',
                        status: s,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/getInspectionsList', data).then(res => {

                        this.page.total = res.data.total
                        this.tableData = res.data.result_array
                        this.loading = false


                    })

                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            async getAreaTemplateCity() {

                try {

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    await http.post('/wapi/v1/getAreaTemplateCity', data).then(res => {

                        this.regionArray = res.data.regionArray
                        this.provinceArray = res.data.provinceArray
                        this.cityArray = res.data.cityArray
                        this.templateArray = res.data.templateArray


                    })

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            // 省份的改变
            handleProvincesClick() {
                this.city = ''
                this.selectCityArray = []
                this.cityArray.forEach(item => {
                    if (item.province_id === this.provinces) {
                        this.selectCityArray.push(item)
                    }
                })
            },

            // 查询
            handleQueryClick() {
                this.page.current = 1
                this.init()
            },
            // 重置
            handleResetClick() {
                this.region = '',
                    this.provinces = '',
                    this.city = '',
                    this.name = '',
                    this.templates = '',
                    this.startDate = '',
                    this.endDate = '',
                    this.status = []
            },
            // 点击详情
            handleDetail(index, row) {
                this.$store.commit('setInspection', {
                    id: row.inspection_id,
                    storeName: row.name,
                    store_id: row.store_id,
                    last_name: row.last_name
                })
                this.$router.push({
                    path: 'cruiseShop/basicInfo',
                })

            },
            // 改变页码信息
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../assets/css/default';

    .container {

        .wrapper {
            padding: 30px 30px;
            width: 100%;
            overflow: auto;
            background: #fff;
            .top {
                .wrap {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: nowrap;
                }
                .font {
                    margin: 0 10px;
                    font-size: $fontSize;
                    color: #3b3b3e;
                    text-align: left;
                }
            }
            .border {
                border-bottom: 2px dashed #e7eaec;
                padding: 20px 0px;
            }
            .bottom {
                margin-top: 20px;
                .table {
                    margin-top: 30px;
                }
                .pagination {
                    margin-top: 50px;
                    text-align: center;
                }
            }
        }

    }
</style>

<style scoped>
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    .a_modal >>> .el-select {
        width: 100%;
    }
</style>




// WEBPACK FOOTER //
// src/pages/cruiseShop/home.vue